// import { configureStore } from "@reduxjs/toolkit";
// import dataReducer from "../Slice/dataSlice";
// import adminAccessReucer from "../Slice/dataSlice";

// const store = configureStore({
//   reducer: {
//     data: dataReducer,
//     adminAccessKey: adminAccessReucer,
//   },
// });

// export default store;

// store.js
import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "../Slice/dataSlice";

const store = configureStore({
  reducer: {
    data: dataReducer,  // Corrected the key to be consistent with the slice name
  },
});

export default store;
